import { z } from 'zod'

export const ApplyLabelRequestSchema = z.object({
  emailIds: z.array(z.string()).min(1),
  label: z.string().min(1),
})

export const ApplyLabelResponseSchema = z.object({
  applied: z.boolean(),
  label: z.string(),
  updated_count: z.number(),
})

export type ApplyLabelRequest = z.infer<typeof ApplyLabelRequestSchema>
export type ApplyLabelResponse = z.infer<typeof ApplyLabelResponseSchema>
